import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import moment from "moment";
moment.locale("id");
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import { googleApiKey } from "./config";

import VCurrencyField from "v-currency-field";

import VueContentLoading from "vue-content-loading";
import { VTextField } from "vuetify/lib"; //Globally import VTextField

Vue.component("vcl", VueContentLoading);
Vue.component("v-text-field", VTextField);

Vue.use(VCurrencyField, {
    locale: "pt-BR",
    decimalLength: 0,
    autoDecimalMode: false,
    min: null,
    max: 1000000000,
    defaultValue: 0,
    valueAsInteger: false,
    allowNegative: false,
});

Vue.config.productionTip = false;

import * as VueGoogleMaps from "vue2-google-maps";
import GmapMarker from "vue2-google-maps/src/components/marker";

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

import NotFound from "./components/NotFound";
import LoadingCard from "./components/LoadingCard";
import LoadingCardSupplier from "./components/supplier/LoadingCard";
import LoadingData from "./components/LoadingData";
import LoadingDataCyan from "./components/supplier/LoadingData";
import ModalConfirm from "./components/ModalConfirm";
import NotFoundCyan from "./components/supplier/NotFound";
import filterComponent from "@/components/Filter";

import "leaflet/dist/leaflet.css";
import 'leaflet-geosearch/dist/geosearch.css'; 
import { Icon } from "leaflet";

Vue.component("GmapMarker", GmapMarker);

//Leaflet
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);

Vue.component("loading-card", LoadingCard);
Vue.component("loading-card-supplier", LoadingCardSupplier);
Vue.component("modalconfirm", ModalConfirm);
Vue.component("not-found", NotFound);
Vue.component("loading-data", LoadingData);
Vue.component("loading-data-cyan", LoadingDataCyan);
Vue.component("not-found-cyan", NotFoundCyan);
Vue.component("filterComponent", filterComponent);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

Vue.use(VueGoogleMaps, {
    installComponents: true,
    load: {
        key: googleApiKey,
        libraries: "places",
    },
});

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");

import { mapState } from "vuex";

Vue.mixin({
    // directives: {money: VMoney},
    data: function() {
        return {
            today: moment(new Date()).format("YYYY-MM-DD"),
            option: {},
            inputrules: {
                required: (value) => !!value || "Tidak boleh kosong",
                notnull: (value) => parseInt(value.toString().replace(/\D/g, "")) > 0 || "Harus lebih dari 0",
                password: (value) => (value && value.length >= 6) || "Password minimal 6 karakter",
                mobilephone: (value) => (value && value.length >= 10 && value.length <= 15) || "Tidak sesuai format",
            },
            usernameRules: [
                (v) => !!v || "Username tidak boleh kosong",
                (v) => v.length > 5 || "Username minimal 6 karakter",
                (v) => v.length <= 20 || "Username maksimal 20 karakter",
            ],
        };
    },
    computed: {
        ...mapState("auth", ["userMenu"]),
    },
    methods: {
        convertDate(val) {
            if (Array.isArray(val)) {
                if (val.length > 0) {
                    return val.map((el) => {
                        return this.$options.filters.tanggalIna(el);
                    });
                } else {
                    return "";
                }
            } else {
                if (val) {
                    return this.$options.filters.tanggalIna(val);
                } else {
                    return "";
                }
            }
        },
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;

            if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
                $event.preventDefault();
            }
        },
        queryString(value) {
            if (value.sort == undefined) {
                value.sort = "";
            }
            let parameterObject = {};
            let parameter = "{";

            if (value.params) {
                value.params.forEach((value, index) => {
                    for (const [key, val] of Object.entries(value)) {
                        parameter += `"filter[${index}][${key}]":"${val}",`;
                    }
                });
            }
            parameter += `"limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`;
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            return parameterObject;
        },
        hasAccess(menu) {
            if (this.userMenu.type == "superuser") {
                return true;
            } else if (this.userMenu.type == "administrator") {
                const menu_slug = this.userMenu.menu.map((el) => el.menu_slug);
                if (!menu_slug.includes(menu)) {
                    return false;
                }
                return true;
            } else {
                return false;
            }
        },
    },
});

Vue.filter("tanggalinput", function(value) {
    var date = moment(value).format("DD MMMM YYYY");
    if (date == "Invalid date" || !value) {
        return "";
    } else {
        return date;
    }
});

Vue.filter("tanggalid", function(value) {
    var date = moment(value).format("DD-MM-YYYY HH:mm:ss");
    if (date == "Invalid date" || !value) {
        return "-";
    } else {
        return date;
    }
});

Vue.filter("tanggalIna", function(value) {
    var date = moment(value).format("DD-MM-YYYY");
    if (date == "Invalid date" || !value) {
        return "-";
    } else {
        return date;
    }
});

Vue.filter("tanggal", function(value) {
    var date = moment(value).format("DD MMMM YYYY");
    if (date == "Invalid date" || !value) {
        return "-";
    } else {
        return date;
    }
});

Vue.filter("tanggaljam", function(value) {
    var date = moment(value).format("DD MMMM YYYY HH:mm:ss");
    if (date == "Invalid date" || !value) {
        return "-";
    } else {
        return date;
    }
});

Vue.filter("haritanggal", function(value) {
    var date = moment(value).format("dddd, DD MMMM YYYY");
    if (date == "Invalid date" || !value) {
        return "-";
    } else {
        return date;
    }
});

Vue.filter("haritanggaljam", function(value) {
    var date = moment(value).format("dddd, DD MMMM YYYY HH:mm:ss");
    if (date == "Invalid date" || !value) {
        return "-";
    } else {
        return date;
    }
});

Vue.filter("toRupiah", function(value) {
    var formatter = new Intl.NumberFormat("id", {
        minimumFractionDigits: 0,
    });

    return "Rp " + formatter.format(parseInt(value));
});

Vue.filter("toStatusConvertSerial", (value) => {
    let status = {
        created: "Menunggu Diproses",
        approved: "Selesai",
    };
    return status[value];
});

Vue.filter("toStatusPOWH", (value) => {
    let status = {
        created: "Menunggu Persetujuan Pusat",
        wh_approved: "Menunggu Persetujuan Supplier",
        wh_rejected: "Ditolak Pusat",
        supp_approved: "Disetujui Oleh Supplier",
        supp_rejected: "Ditolak Oleh Supplier",
        supp_processed: "Proses Pengiriman",
        closed: "Selesai",
    };
    return status[value];
});

Vue.filter("toStatusPDOWH", (value) => {
    let status = {
        created: "Dibuat",
        delivered: "Sudah Diterima",
        on_delivery: "Sedang Dikirim",
    };
    return status[value];
});

Vue.filter("toStatusSDOWH", (value) => {
    let status = {
        created: "Dibuat",
        on_delivery: "Sedang Dikirim",
        delivered: "Sudah Diterima",
        scanned: "Sedang Dikirim",
        completed: "Selesai",
    };
    return status[value];
});

Vue.filter("toStatusSOWH", (value) => {
    let status = {
        created: "Dibuat",
        paid: "Pesanan Sudah Dibayar",
        approved: "Menunggu Diproses Warehouse",
        processed: "Diproses",
        canceled: "Dibatalkan",
        completed: "Selesai",
        approval_refund: "Proses Pengembalian Dana",
    };
    return status[value];
});

Vue.filter("toStatusTO", (value) => {
    let status = {
        created: "Dibuat",
        rejected: "Pesanan Sudah Dibayar",
        approved: "Menunggu Diproses Warehouse",
        processed: "Diproses",
        completed: "Selesai",
    };
    return status[value];
});

Vue.filter("toNumber", function(value) {
    let number = 0;
    var formatter = new Intl.NumberFormat("id", {
        minimumFractionDigits: 0,
    });
    if (!isNaN(parseInt(value))) {
        number = formatter.format(parseInt(value));
    }
    return number;
});

Vue.filter("toColorProduct", (value) => {
    let qty = parseInt(value);
    if (qty <= 0) {
        return "pink lighten-5";
    } else if (qty > 25) {
        return "teal lighten-5";
    } else if (qty <= 25) {
        return "yellow lighten-5";
    }
});

Vue.filter("toStatusTOWH", (value) => {
    let status = {
        created: "Menunggu Persetujuan",
        approved_admin: "Disetujui Admin",
        rejected_admin: "Ditolak Admin",
        approved: "Disetujui",
        rejected: "Ditolak",
        processed: "Sedang Diproses",
        completed: "Selesai",
    };
    return status[value];
});

Vue.filter("toOpnameStatus", (value) => {
    let status = {
        created: "Dibuat",
        approved: "Disetujui",
        rejected: "Ditolak",
    };
    return status[value];
});

Vue.filter("toSREStatus", (value) => {
    let status = {
        created: "Dibuat",
        approved: "Disetujui",
        rejected: "Ditolak",
        closed: "Selesai",
    };
    return status[value];
});

Vue.filter("toStatusReturn", (value) => {
    let status = {
        created: "Permintaan Retur",
        approved: "Retur Disetujui",
        rejected: "Retur Ditolak",
        processed: "Retur Diproses",
        returned: "Retur Selesai",
    };
    return status[value];
});

Vue.filter("toKg", function(value) {
    var formatter = new Intl.NumberFormat("id", {
        minimumFractionDigits: 0,
    });
    if (parseInt(value) >= 1000) {
        return formatter.format(parseInt(value) / 1000) + " kg";
    } else {
        return formatter.format(parseInt(value)) + " gr";
    }
});

Vue.filter("toSalesActivity", (value) => {
    let status = {
        created: "Dibuat",
        paid: "Dibayar",
        approved: "Diproses",
        processed: "Dikirim",
        canceled: "Dibatalkan",
        completed: "Selesai",
    };
    return status[value];
});

Vue.filter("toStatusReturWH", (value) => {
    let status = {
        created: "Menunggu Approval Supplier",
        wh_rejected: "Dibatalkan Oleh Pusat",
        wh_approved: "Menunggu Approval Supplier",
        rejected: "Dibatalkan Oleh Supplier",
        approved: "Menunggu Diproses Supplier",
        processed: "Sedang Diproses Supplier",
        returned: "Selesai",
    };
    return status[value];
});

Vue.filter("toNonOrderStatus", (value) => {
    let status = {
        created: "Menunggu Approval",
        canceled: "Dibatalkan",
        approved: "Disetujui",
    };
    return status[value];
});

Vue.filter("toGender", (value) => {
    let status = {
        male: "Pria",
        female: "Wanita",
    };
    return status[value];
});

Vue.filter("toOneLine", (value) => {
    return value.length > 40 ? value.substr(0, 40) + " ..." : value;
});

/* logistic */
Vue.filter("statusDriver", (value) => {
    let status = {
        stand_by: "Tersedia",
        day_off: "Libur",
        run: "Dalam Perjalanan",
    };
    return status[value];
});

Vue.filter("armadaCondition", (value) => {
    let status = {
        excellent: "Prima",
        good: "Baik",
        fair: "Cukup",
        poor: "Buruk",
    };
    return status[value];
});

Vue.filter("armadaType", (value) => {
    let type = {
        pick_up: "Pick Up",
        grand_max: "Grand Max",
        box_cde: "Box CDE (Engkel)",
        box_cdd: "Box CDD (Double)",
        fuso: "Fuso",
        tronton: "Tronton",
        wingbox: "Wingbox",
        trailer: "Trailer",
        container: "Container",
        other: "Lainnya",
    };
    return type[value];
});

Vue.filter("statusExpedition", (value) => {
    let status = {
        created: "Dibuat",
        approved: "Disetujui",
        processed: "Diproses",
        returned: "Kembali",
        completed: "Selesai",
        delayed: "Tertunda",
    };
    return status[value];
});
